const list = {
    path: 'list',
    component: resolve => require(['@/pages/admin/merchantInvoice/list'], resolve),
    meta: {
        requireAuth: true
    }
}

export default list